import * as React from 'react'
import { Interpolate } from '@doordash/lib-i18n'
import i18n from '../../../i18n'
import {
  OnboardingComponentProps,
  getSimpleOnboardingComponent,
} from '../workflow-components'
import { OnboardingComponent } from 'src/components/organisms/workflow-template/types'

export const InterpolateComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ defaults, values, components }) => {
    return (
      <Interpolate
        i18n={i18n}
        i18nKey={null}
        defaults={defaults}
        values={values}
        components={
          components &&
          components.map((component: OnboardingComponent) =>
            getSimpleOnboardingComponent(component)
          )
        }
      />
    )
  }
)
